const FogShader = {
  uniforms: {
    iTime: { value: 0 },
    fogcolor: { value: [0.9, 0.9, 0.9] },
    alpha: { value: 0.5 },
  },
  vertexShader: `varying highp vec2 vUv;
  #include <common>
  #include <logdepthbuf_pars_vertex>
    void main() {
        #include <logdepthbuf_vertex>
        vUv = uv;
        // gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        gl_Position = vec4(position, 1.0);
    }`,
  fragmentShader: `uniform vec3 fogcolor;
  #include <logdepthbuf_pars_fragment>
    uniform float iTime;
    uniform float alpha;
    
    varying highp vec2 vUv;
    
    float random(vec2 _st) {
        return fract(sin(dot(_st.xy, vec2(0.630, 0.710))) *
            43759.329);
    }
    
    //柏林噪声
    float noise(vec2 _st) {
        vec2 i = floor(_st);
        vec2 f = fract(_st);
    
        float a = random(i);
        float b = random(i + vec2(1.0, 0.0));
        float c = random(i + vec2(0.0, 1.0));
        float d = random(i + vec2(1.0, 1.0));
    
        vec2 u = f * f * (3.0 - 2.0 * f);
    
        return mix(a, b, u.x) +
            (c - a) * u.y * (1.0 - u.x) +
            (d - b) * u.x * u.y;
    }
    
    #define NUM_OCTAVES 6
    
    //布朗分形
    float fbm(vec2 _st) {
        float v = 0.0;
        float a = 0.5;
        vec2 shift = vec2(100.0, 100.0);
        mat2 rot = mat2(cos(0.5), sin(0.5), -sin(0.5), cos(0.50));
    
        for(int i = 0; i < NUM_OCTAVES; ++i) {
            v += a * noise(_st);
            //_st = mul(_st, rot) * 2.0 + shift;
            _st = _st * rot * 2.0 + shift;
            a *= 0.5;
        }
        return v;
    }
    
    vec3 FilterColor(vec3 color1, vec3 color2) {
        //滤色
        return 1.0 - (1.0 - color1) * (1.0 - color2);
    }
    
    // -----------------------------------------------闪电
    
    void mainImage(out vec4 fragColor, in vec2 fragCoord) {
        vec2 uv = vUv;
        vec3 backcolor = vec3(0.);
    
        uv.y = 1.0 - uv.y;
    
        vec2 st = uv * 20.0;
    
        //iTime=iTime*0.3;
        float time=iTime*0.5;
        st.x += time * 0.1;
        st.y -= time * 0.2;
    
        vec3 color;
        vec2 q;
    
        q.x = fbm(st + 0.00 * time * 5.0);
        q.y = fbm(st + vec2(1.0, 1.0));
    
        vec2 r;
        r.x = fbm(st + 1.0 * q + vec2(1.7, 9.2) + 0.15 * time * 5.0);
        r.y = fbm(st + 1.0 * q + vec2(8.3, 2.8) + 0.126 * time * 5.0);
    
        float f = fbm(st + r);
    
        color = mix(vec3(1.0, 1.0, 1.0), vec3(1.0, 1.0, 1.0), clamp((f * f) * 4.0, 0.0, 1.0));
        color = mix(color, vec3(1.0, 1.0, 1.0), clamp(length(q), 0.0, 1.0));
        color = mix(color, vec3(1.0, 1.0, 1.0), clamp(length(r.x), 0.0, 1.0));
        vec3 cloud = vec3((f * f * f + 0.3 * f * f + 0.5 * f) * color);
    
        fragColor = vec4(FilterColor(cloud * fogcolor, backcolor), alpha);
    
    }
    
    void main() {
        #include <logdepthbuf_fragment>
        vec2 fragCoord = gl_FragCoord.xy;
        mainImage(gl_FragColor, fragCoord);
    }`,
}

export default FogShader